import { DataBlock } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ActionButton from '../helpers/ActionButton'
import ItemBlock from '../helpers/ItemBlock'
import SectionDivider from '../helpers/SectionDivider'
import SectionHeading from '../helpers/SectionHeading'
import RelationshipPersonBlock from './RelationshipPersonBlock'

export default function Parents({ person, actionButtonOnClick }) {
  const { t } = useTranslation()
  return (
    <>
      {person?.parents && (
        <>
          <SectionHeading heading={t('tools.adminMerge.headings.parents', 'Family: Parents')} />
          {person?.parents.map((parentPair, index) => {
            const actionButtonType = parentPair.actionButtonType
            const actionButtonOnClickParents = () => {
              actionButtonOnClick({ item: 'Parents', actionButtonType, index })
            }
            return (
              <ItemBlock
                key={parentPair.value.relationshipId}
                selected={actionButtonType === 'UNDO'}
                displayStatus={parentPair.displayStatus}
                isSurvivingPerson={person.isSurvivingPerson}
              >
                <DataBlock
                  heading={t('parents', 'Parents')}
                  data={
                    <>
                      {parentPair?.value?.parent1?.personId && (
                        <RelationshipPersonBlock person={parentPair?.value?.parent1} />
                      )}
                      {parentPair?.value?.parent2?.personId && (
                        <RelationshipPersonBlock person={parentPair?.value?.parent2} />
                      )}
                    </>
                  }
                />
                <ActionButton type={actionButtonType} onClick={actionButtonOnClickParents} />
              </ItemBlock>
            )
          })}
          <SectionDivider />
        </>
      )}
    </>
  )
}
